
import React from 'react';
import gs1PressReleasePdf from 'file-loader?name=docs/[name].[ext]!../../../assets/docs/OECD-GS1 press release on GlobalRecalls portal.pdf';
import officialLaunchSpeechPdf from 'file-loader?name=docs/[name].[ext]!../../../assets/docs/Speech for the official launch of the OECD globalrecalls portal.pdf';

const OfficialLaunch = () => (
  <div className="container main">
    <h2>Presentación oficial</h2>
    <hr/>
    <div className="row">
      <div className="col-sm-6">
        <p>
          El Portal Global de Alertas se presentó e inauguró oficialmente con motivo de la <a href="http://ec.europa.eu/consumers/events/ipsw_2012/index_en.htm" target="_blank">Semana Internacional de la Seguridad de los Productos de Consumo </a>celebrada en Bruselas (Bélgica), el 19 de octubre de 2012. Haga clic aquí para ver el <a
          href="http://ec.europa.eu/consumers/archive/events/ipsw_2012/programme_en.htm"
          target="_blank">orden del día</a>
          y <a href="http://ec.europa.eu/consumers/archive/events/ipsw_2012/gallery_en.htm"
                 target="_blank">fotografías </a>de la ceremonia.
        </p>
      </div>
      <div className="col-sm-6">
        <h4>Presentaciones y discursos</h4>
        <ul>
          <li><a href="http://ec.europa.eu/consumers/events/ipsw_2012/docs/presentation_p_testori_en.pdf"
                 target="_blank">Sra. Paola TESTORI COGGI</a>, <em>Directora General de la DG Salud y Consumidores de la Comisión Europea </em>,
          </li>
          <li><a
            href="http://www.cpsc.gov/en/About-CPSC/Chairman/Speeches/Press-event-launching-GlobalRecalls-Web-Portal/"
            target="_blank">Sra. Inez TENENBAUM</a>, <em>Presidenta de la Comisión estadounidense para la Seguridad de los Productos de Consumo</em>,
          </li>
          <li><a
            href={officialLaunchSpeechPdf}
            target="_blank">Sr. Rintaro TAMAKI</a>, <em>Secretario General Adjunto de la Organización para la Cooperación y el Desarrollo Económicos (OCDE)</em>,
          </li>
          <li><a
            href="http://ec.europa.eu/consumers/events/ipsw_2012/docs/tom_phillips_111_oecd_recalls_portal_presentation_en.pdf"
            target="_blank">Sr. Tom PHILLIPS</a>, <em>Delegado del Grupo de Trabajo de la OCDE sobre la seguridad de los productos de consumo</em>,
          </li>
          <li><a href="http://ec.europa.eu/consumers/events/ipsw_2012/docs/global_portal_on_product_recalls_qa_en.pdf"
                 target="_blank">Preguntas y respuestas sobre el Portal</a>.
          </li>
        </ul>
      </div>
    </div>
    <hr/>
    <div className="row">
      <div className="col-sm-6">
        <h4>Qué dicen los medios</h4>
        <ul>
          <li><a
            href="http://www.heraldsun.com.au/news/national/five-million-items-subject-to-recalls-in-australia-since-july-last-year-accc-data-shows/story-fndo48ca-1226498875141"
            target="_blank">Five million items subject to recalls in Australia since July last year, ACCC data
            shows</a>, <em>Herald Sun</em>, Australia
          </li>
          <li><a
            href="http://www.7sur7.be/7s7/fr/1537/Consommation/article/detail/1520261/2012/10/19/Securite-des-produits-l-OCDE-propose-desormais-un-portail-internet.dhtml"
            target="_blank">Sécurité des produits: l'OCDE propose désormais un portail internet</a>, <em>7 sur 7</em>,
            Bélgica
          </li>
          <li><a
            href="http://slobodnadalmacija.hr/Svijet/tabid/67/articleType/ArticleView/articleId/191794/Default.aspx"
            target="_blank">Zaživio međunarodni portal s listom zabranjenih proizvoda</a>, <em>Slobodna
            Dalimacija</em>, Croacia
          </li>
          <li><a
            href="http://www.enviweb.cz/clanek/zdrav/93471/novy-mezinarodni-portal-s-informacemi-o-nebezpecnych-vyrobcich">Nový
            mezinárodní portál s informacemi o nebezpečných výrobcích</a>, <em>EnviWeb</em>, República Checa
          </li>
          <li><a href="http://www.eu-infothek.com/article/verbraucherschutz-produktrueckrufe-weltweit-auf-einen-klick"
                 target="_blank">Verbraucherschutz – Produktrückrufe weltweit auf einen Klick</a>, <em>Eu
            InfoThek</em>, Europa
          </li>
          <li><a href="http://www.baltic-course.com/eng/good_for_business/?doc=64717">Consumer Safety: priority for EU
            and other global partners</a>, <em>Baltic Course</em>, Europa
          </li>
          <li><a
            href="http://www.francematin.info/L-OCDE-lance-un-portail-en-ligne-pour-renforcer-la-securite-des-produits_a25628.html"
            target="_blank"> L’OCDE lance un portail en ligne pour renforcer la sécurité des produits</a>, <em>France
            Matin</em>, Francia
          </li>
          <li><a href="http://www.caradisiac.com/Globalrecalls-le-site-des-rappels-du-monde-entier-81977.htm"
                 target="_blank">GlobalRecalls : le site des rappels du monde entier</a>, <em>Caradisiac</em>, Francia
          </li>
          <li><a
            href="http://www.info.expoprotection.com/site/FR/LOCDE_lance_un_portail_en_ligne_sur_les_produits_retires_du_marche,C1294,I1312,Zoom-bebca6d9380294d323b99d631e25ba44,FromPage-R.htm?KM_Session=fc8085f94db394b2f9d037eea50098c5"
            target="_blank">L’OCDE lance un portail sur les produits de consommation retirés du marché parce que
            dangereux</a>, <em>L'Info Expoprotection</em>, Francia
          </li>
          <li><a href="http://www.service-public.fr/actualites/002553.html" target="_blank">L’OCDE informe sur les
            produits retirés du marché à travers le monde</a>, <em>Service Public</em>, Francia
          </li>
          <li><a
            href="http://www.helpconsumatori.it/acquisti/sicurezza-prodotti-inaugurato-a-bruxelles-il-global-recalls-portal/54590"
            target="_blank">Sicurezza prodotti, inaugurato a Bruxelles il Global Recalls Portal</a>, <em>Help
            Consumatori</em>, Italia
          </li>
          <li><a href="http://www.barlavento.pt/index.php/noticia?id=54280" target="_blank">Portal informa sobre
            segurança dos produtos</a>, <em>Barlavento</em>, México
          </li>
          <li><a href="http://www.ekonomia24.pl/artykul/706165,944026-Zanim-zrobisz-zakupy.html" target="_blank">Skarb
            dla konsumenta</a>, <em>Ekonomia24</em>, Polonia
          </li>
          <li><a href="http://www.jn.pt/PaginaInicial/Sociedade/Interior.aspx?content_id=2837645" target="_blank">Portal
            reúne produtos retirados de circulação em todo o Mundo</a>, <em>Jornal de Notícias</em>, Portugal
          </li>
          <li><a href="http://www.svet-komunikacie.sk/index.php?ID=11729" target="_blank">On-line: Stiahnuté výrobky z
            trhu</a>, <em>Svet Komunikácie</em>, República Eslovaca
          </li>
          <li><a href="http://www.dnevnik.si/zdravje/1042558583" target="_blank">Predstavili mednarodni spletni portal
            za obveščanje o odpoklicih nevarnih izdelkov</a>, <em>Dnevnik</em>, Eslovenia
          </li>
          <li><a
            href="http://latinalista.com/2012/10/new-online-portal-lets-people-around-the-world-see-which-products-have-been-recalled/"
            target="_blank">New online portal lets people around the world see which products have been recalled</a>,
            <em>Latina Lista</em>, Estados Unidos
          </li>
          <li><a href="http://www.rttnews.com/1986752/check-product-recalls-worldwide-in-a-few-clicks.aspx?type=gn"
                 target="_blank">Check Product Recalls Worldwide In A Few Clicks!</a>, <em>RTT News</em>, Estados Unidos
          </li>
        </ul>
      </div>
      <div className="col-sm-6">
        <h4>Comunicados de prensa</h4>
        <ul>
          <li><a
            href={gs1PressReleasePdf}
            target="_blank">Comunicado de prensa de la OCDE y del GS1 </a>(30 de abril de 2013)
          </li>
          <li>Comunicado de prensa de la OCDE: <a
            href="http://www.oecd.org/newsroom/oecdlaunchesonlineportaltoboostproductsafety.htm"
            target="_blank">Inglés</a>,
            <a href="http://www.oecd.org/fr/presse/locdelanceunportailenlignepourrenforcerlasecuritedesproduits.htm" target="_blank">Francés</a>&nbsp;(19 de octubre de 2012)
          </li>
          <li><a href="http://www.accc.gov.au/content/index.phtml/itemId/1085749/fromItemId/2332" target="_blank">Comisión australiana de Defensa de la Competencia y Protección al Consumidor: la Semana Internacional de la Seguridad de los Productos de Consumo destaca los riesgos de comprar por Internet </a>&nbsp;(19 de octubre de 2012)
          </li>
          <li>Comunicado de prensa de la <a href="http://europa.eu/rapid/press-release_IP-12-1127_en.htm?locale=en"
                                       target="_blank">Comisión Europea </a>y <a href="http://europa.eu/rapid/press-release_MEMO-12-791_en.htm?locale=en" target="_blank">apartado de preguntas y respuestas</a>&nbsp;(19 de octubre de 2012)
          </li>
        </ul>
      </div>
    </div>
  </div>
);

export default OfficialLaunch;



// WEBPACK FOOTER //
// ./src/views/static/es/official-launch.js